// extracted by mini-css-extract-plugin
module.exports = {"content":"NftLabelAndContent_content__2cXXX"};